export default "__VITE_ASSET__2aa00ad1__"